<template>
  <header
    class="relative flex pt-navbar-height sm:min-h-[45vh]"
    :class="[data.text ? 'min-h-svh' : 'min-h-[45vh]', !data.color_theme?.value || data.color_theme?.value === 'blue' ? `
      bg-theme-500 text-white
    ` : `bg-theme-200`]"

    :style="colorTheme"
  >
    <Container v-animate-children-in-from-bottom class="w-full" indent="default-but-on-mobile-lg">
      <div class="grid h-full max-w-container-max py-14 lg:grid-cols-2">
        <div class="mr-[10%] flex flex-col max-lg:justify-between">
          <!-- SURTITLE -->
          <p class="typo-label-md md:mt-2 md:typo-label-lg">
            {{ data.surtitle || data.parent?.title }}
          </p>

          <!-- TITLE -->
          <h1
            v-if="data.heading"
            class="mt-32 typo-heading-xl lg:mb-26 lg:mt-16 md:text-heading-2xl md:typo-display-lg"
            v-html="data.heading"
          />
        </div>

        <!-- TEXT -->
        <div v-if="data.text" class="mb-3 h-fit grow-0 border-b max-lg:mt-8 md:border-b-2">
          <div
            class="pb-[1.75em] typo-body-xl md:typo-body-4xl"
            v-html="data.text"
          />
        </div>
      </div>
    </Container>
  </header>
</template>

<script lang="ts" setup>
import type { HerosMainHeroDetailFragment } from '#gql'

const props = defineProps<{
  data: Enforce<HerosMainHeroDetailFragment>
}>()

const colorTheme = useGetColorThemeStylesComponent(props.data.color_theme?.value)
</script>
